export default __webpack_public_path__ + "static/media/news-7.d5d0974f.png";